import { render } from "./RiskAssessmentMatrix.vue?vue&type=template&id=6409cb9d&scoped=true"
import script from "./RiskAssessmentMatrix.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentMatrix.vue?vue&type=script&lang=js"

import "./RiskAssessmentMatrix.vue?vue&type=style&index=0&id=6409cb9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6409cb9d"]])

export default __exports__